import React, { useEffect,  useState } from "react";

import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row, Offcanvas, Button } from "react-bootstrap";
import { FiMenu } from "react-icons/fi";
import PayRollTable from "../../../components/Tables/PayRollTable";
import DroupdownFilterBox from "../../../components/FilterBox/PayRollFilter/PayRollDropDownFilter";
import {
  DeptGrpList,
  DeptGrpSalSumm,
  DeptGrpSalSummdataFun,
} from "../../../Redux/Slice/PayRoll/PayRollSlice";
import PayRollFilterBox from "../../../components/FilterBox/PayRollFilter/PayRollFilter";
import { Loader } from "../../../components/Loader/Loader";
import { useTheme } from "../../../Themecontext/Themecontext";

export const DepWiseSalarySummary = () => {
  const dispatch = useDispatch();

  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { DataMain } = useSelector((state) => state.ClientLogin || {});
  const { DeptGrpListdata, DeptGrpSalSummdata } = useSelector(
    (state) => state.PayRollSlice || {},
  );

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWPAYROLL");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWPAYROLLDARK",
  );

  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  let YearId = Cookies.get("FinancialYear");

  // ================= FILTER STATE =================
  const [filters, setFilters] = useState({
    year: [],
    month: [],
    department: [],
  });

  const [search, setSearch] = useState({
    year: "",
    month: "",
    department: "",
  });

  const [selectedYear, setSelectedYear] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState([]);
  const [selectedDept, setSelectedDept] = useState([]);

  const [selectedYearId, setSelectedYearId] = useState([]);
  const [selectedMonthId, setSelectedMonthId] = useState([]);
  const [selectedDeptId, setSelectedDeptId] = useState([]);

  const [showFilter, setShowFilter] = useState(false);

  const handleShow = () => setShowFilter(true);
  const handleClose = () => setShowFilter(false);

  // ================= API CALL =================

  useEffect(() => {
    dispatch(DeptGrpSalSummdataFun());
    dispatch(
      DeptGrpList({
        Firm: Firm,
        Year: YearId,
      }),
    );

    dispatch(
      DeptGrpSalSumm({
        Firm: Firm,
        Year: YearId,
      }),
    );
  }, [dispatch, Firm, YearId]);

  const monthOptions = [
    { id: 4, month: "April" },
    { id: 5, month: "May" },
    { id: 6, month: "June" },
    { id: 7, month: "July" },
    { id: 8, month: "August" },
    { id: 9, month: "September" },
    { id: 10, month: "October" },
    { id: 11, month: "November" },
    { id: 12, month: "December" },
    { id: 1, month: "January" },
    { id: 2, month: "February" },
    { id: 3, month: "March" },
  ];

  const formatIndian = (amount) => {
    if (!amount && amount !== 0) return "";
    return Number(amount).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  // ================= DATA =================

  const yearList =
    DataMain?.AC_Year_List?.map((item) => ({
      label: item?.AcYear,
      value: item?.AcYearID,
    })) || [];

  const monthList =
    monthOptions?.map((item) => ({
      label: item?.month,
      value: item?.id,
    })) || [];
  const departmentList =
    DeptGrpListdata?.Data?.map((item) => ({
      label: item?.DepartmentGroup,
      value: item?.DeptGroupID,
    })) || [];

  const toggleItem = (type, item) => {
    setFilters((prev) => {
      const selected = prev[type];

      return {
        ...prev,
        [type]: selected.includes(item.value)
          ? selected.filter((i) => i !== item.value)
          : [...selected, item.value],
      };
    });
  };
  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);

    setFilters((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };
  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };
  const applyFilter = () => {
    dispatch(DeptGrpSalSummdataFun());

    const finalYearIDs =
      selectedYearId.length > 0
        ? selectedYearId
        : [Cookies.get("FinancialYear")];

    dispatch(
      DeptGrpSalSumm({
        Firm: Firm,
        Year: finalYearIDs.join(","),
        MonthIDs: selectedMonthId.join(","), // FIX
        DeptGrpIDs: selectedDeptId.join(","), // FIX
      }),
    );


  };

  const applyFilters1 = () => {
    dispatch(DeptGrpSalSummdataFun());

    const finalYearIDs =
      filters.year.length > 0
        ? filters.year
        : selectedYearId.length > 0
          ? selectedYearId
          : [Cookies.get("FinancialYear")];

    dispatch(
      DeptGrpSalSumm({
        Firm: Firm,
        Year: finalYearIDs.join(","),
        MonthIDs: filters.month.join(","),
        DeptGrpIDs: filters.department.join(","),
      }),
    );

    setShowFilter(false)
  };

  const getRows =
    DeptGrpSalSummdata?.Dtl?.map((label, index) => ({
      // srNumber: index + 1,
      DeptGrpName: label.DeptGrpName,
      Apr_TotalEmp: label.Apr_TotalEmp,
      Apr_TotalSal: label.Apr_TotalSal,
      May_TotalEmp: label.May_TotalEmp,
      May_TotalSal: label.May_TotalSal,
      Jun_TotalEmp: label.Jun_TotalEmp,
      Jun_TotalSal: label.Jun_TotalSal,
      Jul_TotalEmp: label.Jul_TotalEmp,
      Jul_TotalSal: label.Jul_TotalSal,
      Aug_TotalEmp: label.Aug_TotalEmp,
      Aug_TotalSal: label.Aug_TotalSal,
      Sep_TotalEmp: label.Sep_TotalEmp,
      Sep_TotalSal: label.Sep_TotalSal,
      Oct_TotalEmp: label.Oct_TotalEmp,
      Oct_TotalSal: label.Oct_TotalSal,
      Nov_TotalEmp: label.Nov_TotalEmp,
      Nov_TotalSal: label.Nov_TotalSal,
      Dec_TotalEmp: label.Dec_TotalEmp,
      Dec_TotalSal: label.Dec_TotalSal,
      Jan_TotalEmp: label.Jan_TotalEmp,
      Jan_TotalSal: label.Jan_TotalSal,
      Feb_TotalEmp: label.Feb_TotalEmp,
      Feb_TotalSal: label.Feb_TotalSal,
      Mar_TotalEmp: label.Mar_TotalEmp,
      Mar_TotalSal: label.Mar_TotalSal,
      TotalEmployee: label.TotalEmployee,
      TotalSalary: label.TotalSalary,
    })) || [];

  const getColumns = [
    {
      key: "srNumber",
      label: "Sr. No.",
      align: "center",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      key: "DeptGrpName",
      label: "Department Group",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      key: "TotalSalary",
      label: "Total Salary",
      align: "right",
      format: "true",
    },
    { key: "Apr_TotalEmp", label: "Apr. Emp", align: "right" },
    {
      key: "Apr_TotalSal",
      label: "Apr. Salary",
      align: "right",
      format: "true",
    },
    { key: "May_TotalEmp", label: "May. Emp", align: "right" },
    {
      key: "May_TotalSal",
      label: "May. Salary",
      align: "right",
      format: "true",
    },
    { key: "Jun_TotalEmp", label: "Jun. Emp", align: "right" },
    {
      key: "Jun_TotalSal",
      label: "Jun. Salary",
      align: "right",
      format: "true",
    },
    { key: "Jul_TotalEmp", label: "Jul. Emp", align: "right" },
    {
      key: "Jul_TotalSal",
      label: "Jul. Salary",
      align: "right",
      format: "true",
    },
    { key: "Aug_TotalEmp", label: "Aug. Emp", align: "right" },
    {
      key: "Aug_TotalSal",
      label: "Aug. Salary",
      align: "right",
      format: "true",
    },
    { key: "Sep_TotalEmp", label: "Sep. Emp", align: "right" },
    {
      key: "Sep_TotalSal",
      label: "Sep. Salary",
      align: "right",
      format: "true",
    },
    { key: "Oct_TotalEmp", label: "Oct. Emp", align: "right" },
    {
      key: "Oct_TotalSal",
      label: "Oct. Salary",
      align: "right",
      format: "true",
    },
    { key: "Nov_TotalEmp", label: "Nov. Emp", align: "right" },
    {
      key: "Nov_TotalSal",
      label: "Nov. Salary",
      align: "right",
      format: "true",
    },
    { key: "Dec_TotalEmp", label: "Dec. Emp", align: "right" },
    {
      key: "Dec_TotalSal",
      label: "Dec. Salary",
      align: "right",
      format: "true",
    },
    { key: "Jan_TotalEmp", label: "Jan. Emp", align: "right" },
    {
      key: "Jan_TotalSal",
      label: "Jan. Salary",
      align: "right",
      format: "true",
    },
    { key: "Feb_TotalEmp", label: "Feb. Emp", align: "right" },
    {
      key: "Feb_TotalSal",
      label: "Feb. Salary",
      align: "right",
      format: "true",
    },
    { key: "Mar_TotalEmp", label: "Mar. Emp", align: "right" },
    {
      key: "Mar_TotalSal",
      label: "Mar. Salary",
      align: "right",
      format: "true",
    },
    { key: "TotalEmployee", label: "Total Employees", align: "right" },
  ];

  // ================= CARD STYLE =================
  const cardStyle = {
    background: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
    border: `1px solid ${isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour10
      }`,
    borderLeft: `6px solid ${isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour10
      }`,
    borderRadius: "12px",
    padding: "12px",
    textAlign: "center",
  };

  const titleStyle = {
    color: isdark === "light" ? iscolour?.Colour12 : iscolourDark?.Colour12,
    fontWeight: "600",
  };

  const valueStyle = {
    marginTop: "10px",
    fontWeight: "600",
    color: isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour10,
  };

  if (DeptGrpSalSummdata === null || DeptGrpSalSummdata === "no") {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Loader />
      </div>
    );
  }
  return (
    <div
      style={{
        padding: "16px",
        background:
          isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
        minHeight: "100vh",
      }}
    >
      {/* HEADER + MOBILE BTN */}
      <Row className="mb-3 align-items-center">
        <div className="d-lg-none d-flex justify-content-end mb-3">
          <Button
            onClick={handleShow}
            style={{
              backgroundColor:
                isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7,
              color:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour12,
              border: "none",
              borderRadius: "10px",
              padding: "8px 12px",
              boxShadow: "0 4px 10px rgba(0,0,0,0.18)",
            }}
          >
            <FiMenu size={22} />
          </Button>
        </div>
      </Row>

      {/* ================= MOBILE FILTER ================= */}
      <Offcanvas
        show={showFilter}
        onHide={handleClose}
        placement="start"
        style={{
          background:
            isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
        }}
      >
        <Offcanvas.Header
          closeButton
          closeVariant={isdark === "dark" ? "white" : undefined}
        >
          <Offcanvas.Title
            style={{
              color:
                isdark === "light"
                  ? iscolour?.Colour12
                  : iscolourDark?.Colour12,
            }}
          >
            Filters
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <PayRollFilterBox
              title="Year"
              items={yearList}
              search={search.year}
              setSearch={(val) => handleSearch("year", val)}
              selectedItems={filters.year}
              toggleItem={(item) => toggleItem("year", item)}
              selectAll={() => selectAll("year", yearList)}
            />

            <PayRollFilterBox
              title="Month"
              items={monthList}
              search={search.month}
              setSearch={(val) => handleSearch("month", val)}
              selectedItems={filters.month}
              toggleItem={(item) => toggleItem("month", item)}
              selectAll={() => selectAll("month", monthList)}
            />

            <PayRollFilterBox
              title="Department"
              items={departmentList}
              search={search.department}
              setSearch={(val) => handleSearch("department", val)}
              selectedItems={filters.department}
              toggleItem={(item) => toggleItem("department", item)}
              selectAll={() => selectAll("department", departmentList)}
            />

            <Button
              onClick={applyFilters1}
              style={{
                width: "100%",
                // height: "44px",
                borderRadius: "12px",
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour12,
                border: "none",
                padding: "12px",
                fontWeight: "700",
              }}
              className="common-hover-btn"
            >
              Apply Filters
            </Button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      {/* ================= DESKTOP FILTER ================= */}
      <Col xl={12} className="d-none d-lg-block">
        <div
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
            padding: "15px",
            borderRadius: "12px",
            border: `2px solid ${isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour5
              }`,
            marginBottom: "20px",
          }}
        >
          <Row>
            <Col xl={3} lg={6} md={6} sm={6} xs={12}>
              <DroupdownFilterBox
                label="Year"
                data={yearList}
                selectedValue={selectedYear}
                setSelectedValue={setSelectedYear}
                selectedId={selectedYearId}
                setSelectedId={setSelectedYearId}
                placeholder="Select Year"
                isdark={isdark}
                iscolour={iscolour}
                iscolourDark={iscolourDark}
              />
            </Col>

            <Col xl={3} lg={6} md={6} sm={6} xs={12}>
              <DroupdownFilterBox
                label="Month"
                data={monthList}
                selectedValue={selectedMonth}
                setSelectedValue={setSelectedMonth}
                selectedId={selectedMonthId}
                setSelectedId={setSelectedMonthId}
                placeholder="Select Month"
                isdark={isdark}
                iscolour={iscolour}
                iscolourDark={iscolourDark}
              />
            </Col>

            <Col xl={3} lg={6} md={6} sm={6} xs={12}>
              <DroupdownFilterBox
                label="Department"
                data={departmentList}
                selectedValue={selectedDept}
                setSelectedValue={setSelectedDept}
                selectedId={selectedDeptId}
                setSelectedId={setSelectedDeptId}
                placeholder="Select Department"
                isdark={isdark}
                iscolour={iscolour}
                iscolourDark={iscolourDark}
              />
            </Col>

            <Col
              xl={3}
              lg={6}
              md={6}
              sm={6}
              xs={12}
              style={{ display: "flex", alignItems: "end" }}
            >
              <button
                onClick={applyFilter}
                style={{
                  padding: "12px",
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour6
                      : iscolourDark?.Colour7,
                  color:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour12,
                  width: "100%",
                  border: "none",
                  borderRadius: "12px",
                  fontWeight: "700",
                }}
              >
                Apply Filters
              </button>
            </Col>
          </Row>
        </div>
      </Col>

      {/* ================= SUMMARY ================= */}
      <Row className="g-3">
        <Col xl={6} lg={6} sm={6} xs={12}>
          <div style={cardStyle}>
            <h4 style={valueStyle}>
              {" "}
              {formatIndian(DeptGrpSalSummdata?.Summ?.[0]?.TotalSalary)}
            </h4>
            <h6 style={titleStyle}>Total Salary</h6>
          </div>
        </Col>

        <Col xl={6} lg={6} sm={6} xs={12}>
          <div style={cardStyle}>
            <h4 style={valueStyle}>
              {DeptGrpSalSummdata?.Summ[0]?.TotalEmployee}
            </h4>
            <h6 style={titleStyle}>Total Employees</h6>
          </div>
        </Col>
      </Row>

      {/* ================= TABLE ================= */}
      <div
        style={{
          marginTop: "25px",
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
        }}
      >
        <div
          style={{
            padding: "14px",
            background:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7,
            color: "#fff",
            fontWeight: "600",
            fontSize: "18px",
            margin: 0,
            letterSpacing: "1px",
          }}
        >
          DEPARTMENTWISE SALARY
        </div>

        <PayRollTable columns={getColumns} data={getRows} showSearch />
      </div>
    </div>
  );
};
